import { Action } from '@ngrx/store';

import { AddConceptVersionModel } from "../../models/AddConceptVersionModel";

export const DUPLICATION_FOUND = '[Vocabulary] Duplication Found';

export class DuplicationFoundAction implements Action {
  readonly type = DUPLICATION_FOUND;

  constructor(public payload: { model: AddConceptVersionModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/DuplicationFoundAction.ts